import React, { useState, useEffect } from 'react';
import { Select, Toast, Button } from '@douyinfe/semi-ui';
import { IconRefresh, IconUserGroup } from '@douyinfe/semi-icons';
import request from '../../utils/request';

const GroupSelector = ({ value, onChange, disabled }) => {
    const [loading, setLoading] = useState(false);
    const [groupList, setGroupList] = useState([]);

    const fetchGroupList = async () => {
        setLoading(true);
        try {
            const response = await request.get('/go/spc/join_group/mlist_group/', {
                params: {
                    with_all_status: 1
                }
            });
            if (response.errno === 0) {
                setGroupList(response.list || []);
            } else {
                Toast.error(response.errstr || '获取群组列表失败');
            }
        } catch (error) {
            console.error('获取群组列表失败:', error);
            Toast.error('获取群组列表失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGroupList();
    }, []);

    const handleChange = (selectedUids) => {
        onChange?.(selectedUids);
    };

    const renderCustomOption = (group) => {
        const optionStyle = {
            display: 'flex',
            paddingLeft: 24,
            paddingTop: 10,
            paddingBottom: 10,
        };
        return (
            <Select.Option
                key={group.uid}
                value={group.uid}
                style={optionStyle}
                showTick={true}
            >
                <div style={{ fontSize: 14 }}>{group.name}</div>
            </Select.Option>
        );
    };

    return (
        <Select
            loading={loading}
            value={value}
            onChange={handleChange}
            style={{ width: '100%' }}
            placeholder="请选择群组（多个用逗号分隔）"
            filter
            showClear
            multiple
            maxTagCount={3}
            filterOption={(input, option) => {
                const name = option?.label?.toString() || '';
                return name.toLowerCase().includes(input.toLowerCase());
            }}
            prefix={<IconUserGroup style={{ color: 'var(--semi-color-primary)' }} />}
            disabled={disabled}
            outerTopSlot={
                <Button
                    icon={<IconRefresh />}
                    type="tertiary"
                    onClick={fetchGroupList}
                    style={{ width: '100%', marginBottom: '8px' }}
                >
                    刷新列表
                </Button>
            }
        >
            {groupList.map(group => renderCustomOption(group))}
        </Select>
    );
};

export default GroupSelector;